import React from 'react';
import { Flex } from '../flex';
import { InfoRow, InfoRowLabel, InfoRowText } from './styled';

export interface InfoOverviewProps {
  items: {
    key: string;
    value?: string | number;
    accented?: boolean;
  }[];
}

export const InfoOverview: React.FC<InfoOverviewProps> = ({ items }) => (
  <Flex flexDirection="column" width="100%">
    {items.map((item) => (
      <InfoRow key={item.key} accented={item.accented}>
        <InfoRowLabel>{item.key}</InfoRowLabel>
        <InfoRowText>{item.value || '-'}</InfoRowText>
      </InfoRow>
    ))}
  </Flex>
);
